
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { LineChart } from 'lucide-react';
import { ResponsiveContainer, LineChart as ReLineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts';

const COLORS = ['#9b87f5', '#6E59A5', '#D6BCFA', '#403E43', '#1A1F2C'];

interface StreamingPerformanceChartProps {
  streamingData: any[];
}

const StreamingPerformanceChart: React.FC<StreamingPerformanceChartProps> = ({ streamingData }) => {
  return (
    <Card className="bg-card/95 border-border/50">
      <CardHeader>
        <CardTitle className="text-xl flex items-center gap-2 text-white/95">
          <LineChart className="h-5 w-5 text-soundcharts-purple" />
          Streaming Performance
        </CardTitle>
        <CardDescription className="flex flex-wrap gap-2">
          <span className="text-white/70">Track your streaming metrics over time</span>
          <div className="flex gap-2 text-xs mt-1">
            {['Spotify', 'Apple Music', 'Other'].map((platform, index) => (
              <Badge key={platform} variant="outline" className="border-soundcharts-purple/30 bg-black/20">
                <span className="h-2 w-2 rounded-full mr-1" style={{ backgroundColor: COLORS[index] }}></span>
                <span className="text-white/90">{platform}</span>
              </Badge>
            ))}
          </div>
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="h-[300px] w-full">
          <ResponsiveContainer width="100%" height="100%">
            <ReLineChart data={streamingData}>
              <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="rgba(255,255,255,0.1)" />
              <XAxis 
                dataKey="name" 
                tick={{ fill: 'rgba(255,255,255,0.7)', fontSize: 12 }} 
                tickLine={false} 
                axisLine={{ stroke: 'rgba(255,255,255,0.1)' }} 
              />
              <YAxis 
                tick={{ fill: 'rgba(255,255,255,0.7)', fontSize: 12 }} 
                tickLine={false} 
                axisLine={{ stroke: 'rgba(255,255,255,0.1)' }} 
              />
              <Tooltip 
                contentStyle={{ 
                  backgroundColor: 'rgba(0,0,0,0.8)', 
                  border: '1px solid rgba(255,255,255,0.1)',
                  borderRadius: '8px',
                  color: 'rgba(255,255,255,0.9)'
                }} 
              />
              <Line type="monotone" dataKey="spotify" stroke={COLORS[0]} strokeWidth={2} dot={{ fill: COLORS[0] }} activeDot={{ r: 6 }} />
              <Line type="monotone" dataKey="apple" stroke={COLORS[1]} strokeWidth={2} dot={{ fill: COLORS[1] }} activeDot={{ r: 6 }} />
              <Line type="monotone" dataKey="other" stroke={COLORS[2]} strokeWidth={2} dot={{ fill: COLORS[2] }} activeDot={{ r: 6 }} />
            </ReLineChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
};

export default StreamingPerformanceChart;
